import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

// user
import userProfile from '../pages/users/profile/userProfile.vue'
import userCards from '../pages/users/cards/userCards.vue'
import userEdit from '../pages/users/edit/userEdit.vue'


// error
import Error400 from '../pages/error/error400';
import Error401 from '../pages/error/error401';
import Error403 from '../pages/error/error403';
import Error404 from '../pages/error/error404';
import Error500 from '../pages/error/error500';
import Error503 from '../pages/error/error503';

/* Authentication */
import LoginOne from '../pages/authentication/login_one';

import RegisterImage from '../pages/authentication/register_image';
import RegisterImage2 from '../pages/authentication/register_image2';
import Unlock from '../pages/authentication/unlock.vue';
import ForgetPassword from '../pages/authentication/forget_password';
import ResetPassword from '../pages/authentication/reset_password';
import Maintenance from '../pages/authentication/maintenance.vue'
/* Auth */
import login from '../auth/login.vue';
import Register from '../auth/register.vue';
import Forgot_Password from '../auth/forgotPassword.vue';


import upload from '../pages/upload/upload.vue'
import upload_vdo from '../pages/upload/upload_vdo.vue'
import upload_images from '../pages/upload/upload_images.vue'
import upload_videos from '../pages/upload/upload_videos.vue'
import upload_hl from '../pages/upload/upload_hl.vue'
import upload_images_hl from '../pages/upload/upload_images_hl.vue'

import order from '../pages/running/order.vue'
import order_mhao from '../pages/running/order_mhao.vue'
import order_mhao_view from '../pages/running/order_mhao_view.vue'
import order_hybrid_wholesale_view from '../pages/running/order_hybrid_wholesale_view.vue'
import order_admin from '../pages/running/order_admin.vue'
import event_adjustment from '../pages/running/event_adjustment.vue'
import event_adjustment_admin from '../pages/running/event_adjustment_admin.vue'
import event_adjustment_promote from '../pages/running/event_adjustment_promote.vue'
import event_create from '../pages/running/event_create.vue'
import coupon from '../pages/running/coupon.vue'
import credit_create from '../pages/running/credit_create.vue'
import system_dashboard from '../pages/running/system_dashboard.vue'
import photo_admin_dashboard from '../pages/running/photo_admin_dashboard.vue'
import photo_admin_promote from '../pages/running/photo_admin_promote.vue'
import administrator_dashboard from '../pages/running/administrator_dashboard.vue'


import home from '../pages/running/home.vue'
import tshirt from '../pages/running/tshirtOrder.vue'
import participate from '../pages/running/participate.vue'
import partner from '../pages/running/partner.vue'
import wallet from '../pages/running/wallet.vue'
import withdrawalHistory from '../pages/running/withdrawalHistory.vue'


const routes = [
  {
    path: '/',
    component: Body,

    children: [
      {
        path: '',
        name: 'home',
        component: home,
        meta: {
          title: 'RUNNING.IN.TH',
        }
      },
      {
        path: '/tshirt',
        name: 'tshirt',
        component: tshirt,
        meta: {
          title: 'RUNNING.IN.TH ',
        }
      },
      {
        path: '/participate',
        name: 'participate',
        component: participate,
        meta: {
          title: 'กิจกรรมที่เข้าร่วม - RUNNING.IN.TH ',
        }
      },
      {
        path: '/partner',
        name: 'partner',
        component: partner,
        meta: {
          title: 'กิจกรรมที่ดูแล - RUNNING.IN.TH ',
        }
      },
      {
        path: 'upload/:q',
        name: 'upload',
        component: upload,
        meta: {
          title: 'UPLOAD - RUNNING.IN.TH ',
        }
      },
      {
        path: 'upload-vdo/:q',
        name: 'upload_vdo',
        component: upload_vdo,
        meta: {
          title: 'UPLOAD VDO - RUNNING.IN.TH ',
        }
      },
      {
        path: 'upload_hl/:q',
        name: 'upload_hl',
        component: upload_hl,
        meta: {
          title: 'UPLOAD HL - RUNNING.IN.TH ',
        }
      },
      {
        path: 'coupon/:q',
        name: 'coupon',
        component: coupon,
        meta: {
          title: 'UPLOAD HL',
        }
      },
      {
        path: 'upload-images/:q',
        name: 'upload-images',
        component: upload_images,
        meta: {
          title: 'รูปที่ upload สำเร็จ - RUNNING.IN.TH ',
        }
      },
      {
        path: 'upload-videos/:q',
        name: 'upload-videos',
        component: upload_videos,
        meta: {
          title: 'รูปที่ upload สำเร็จ - RUNNING.IN.TH ',
        }
      },
      {
        path: 'order/:q',
        name: 'order',
        component: order,
        meta: {
          title: 'ORDER - RUNNING.IN.TH ',
        }
      },
      {
        path: 'orders/:q',
        name: 'order_mhao',
        component: order_mhao,
        meta: {
          title: 'ORDER - RUNNING.IN.TH ',
        }
      },
      {
        path: 'orders/:q/view/:confirm_key',
        name: 'order_mhao_view',
        component: order_mhao_view,
        meta: {
          title: 'ORDER - RUNNING.IN.TH ',
        }
      },
      {
        path: 'order/:q/view/:confirm_key',
        name: 'order_hybrid_wholesale_view',
        component: order_hybrid_wholesale_view,
        meta: {
          title: 'ORDER - RUNNING.IN.TH ',
        }
      },
      {
        path: 'order-admin/:q',
        name: 'order_admin',
        component: order_admin,
        meta: {
          title: 'DASHBOARD - RUNNING.IN.TH ',
        }
      },
      {
        path: 'event-adjustment/:q',
        name: 'event_adjustment',
        component: event_adjustment,
        meta: {
          title: 'ADJUSTMENT - RUNNING.IN.TH ',
        }
      },
      {
        path: 'event-adjustment-admin/:q',
        name: 'event_adjustment_admin',
        component: event_adjustment_admin,
        meta: {
          title: 'ADMIN ADJUSTMENT - RUNNING.IN.TH ',
        }
      },
      {
        path: 'event-adjustment-promote/:q',
        name: 'event_adjustment_promote',
        component: event_adjustment_promote,
        meta: {
          title: 'ADMIN ADJUSTMENT PROMOTE - RUNNING.IN.TH ',
        }
      },
      {
        path: 'event-create',
        name: 'event_create',
        component: event_create,
        meta: {
          title: 'CREATE EVENT - RUNNING.IN.TH ',
        }
      },
      {
        path: 'credit-create',
        name: 'credit_create',
        component: credit_create,
        meta: {
          title: 'ADD CREDIT - RUNNING.IN.TH ',
        }
      },
      
     
      {
        path: 'system-dashboard',
        name: 'system_dashboard',
        component: system_dashboard,
        meta: {
          title: 'SYSTEM DASHBOARD',
        }
      },
      {
        path: 'photo-admin-dashboard',
        name: 'photo_admin_dashboard',
        component: photo_admin_dashboard,
        meta: {
          title: 'PHOTO ADMIN DASHBOARD',
        }
      },
      {
        path: 'photo-admin-promote',
        name: 'photo_admin_promote',
        component: photo_admin_promote,
        meta: {
          title: 'PHOTO ADMIN PROMOTE',
        }
      },
      {
        path: 'administrator-dashboard',
        name: 'administrator_dashboard',
        component: administrator_dashboard,
        meta: {
          title: 'administrator dashboard  ',
        }
      },
      {
        path: 'wallet',
        name: 'wallet',
        component: wallet,
        meta: {
          title: 'WALLET - RUNNING.IN.TH ',
        }
      },
      {
        path: 'withdrawal-history',
        name: 'withdrawal-history',
        component: withdrawalHistory,
        meta: {
          title: 'WITHDRAWAL HISTORY - RUNNING.IN.TH ',
        }
      },

    ]
  },
  {
    path: '/dashboard',
    component: Body,
    children: [
      {
        path: 'default',
        name: 'default',
        component: home,
        meta: {
          title: 'RUNNING.IN.TH ',
        }
      },
    ]
  },
  {
    path: '/users',
    component: Body,
    children: [
      {
        path: "profile",
        name: "profile",
        component: userProfile,
        meta: {
          title: "Users Profile | RUNNING.IN.TH",
        },
      },
      {
        path: "edit",
        name: "edit",
        component: userEdit,
        meta: {
          title: "Users Edit | RUNNING.IN.TH",
        },
      },
      {
        path: "cards",
        name: "cards",
        component: userCards,
        meta: {
          title: "Users Cards | RUNNING.IN.TH",
        },
      }
    ]
  },
  {
    path: '/error-400',
    name: 'Error400',
    component: Error400,
    meta: {
      title: 'Error400 | RUNNING.IN.TH',
    }
  },
  {
    path: '/error-401',
    name: 'Error401',
    component: Error401,
    meta: {
      title: 'Error401 | RUNNING.IN.TH',
    }
  },
  {
    path: '/error-403',
    name: 'Error403',
    component: Error403,
    meta: {
      title: 'Error403 | RUNNING.IN.TH',
    }
  },
  {
    path: '/error-404',
    name: 'Error404',
    component: Error404,
    meta: {
      title: 'Error404 | RUNNING.IN.TH',
    }
  },
  {
    path: '/error-500',
    name: 'Error500',
    component: Error500,
    meta: {
      title: 'Error500 | RUNNING.IN.TH',
    }
  },
  {
    path: '/error-503',
    name: 'Error503',
    component: Error503,
    meta: {
      title: 'Error503 | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/login/one',
    name: 'LoginOne',
    component: LoginOne,
    meta: {
      title: 'LoginOne | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/register/image',
    name: 'RegisterImage',
    component: RegisterImage,
    meta: {
      title: 'RegisterImage | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/register/image2',
    name: 'RegisterImage2',
    component: RegisterImage2,
    meta: {
      title: 'RegisterImage2 | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/unlockuser',
    name: 'Unlock',
    component: Unlock,
    meta: {
      title: 'Unlock | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/forgetpassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      title: 'ForgetPassword | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: 'ResetPassword | RUNNING.IN.TH',
    }
  },
  {
    path: '/authentication/maintenance',
    name: 'Maintenance',
    component: Maintenance,
    meta: {
      title: 'Maintenance | RUNNING.IN.TH',
    }
  },
    {
    path: '/auth',
    children: [
      {
        path: 'login',
        name: 'Login 1',
        component: login,
        meta: {
          title: 'Photo Management | RUNNING.IN.TH',
        }
      },
      {
        path: 'forgot-password',
        name: 'Forgot_Password',
        component: Forgot_Password,
        meta: {
          title: 'Forgot_Password | RUNNING.IN.TH',
        }
      },
      {
        path: 'register',
        name: 'register 1',
        component: Register,
        meta: {
          title: ' Register | RUNNING.IN.TH',
        }
      }
    ]
  },
  
]
const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.meta.title)
    document.title = to.meta.title;
  const path = ['/auth/login', '/auth/register', '/auth/forgot-password'];
  if (path.includes(to.path) || localStorage.getItem('jwt')) {
    return next();
  }
  next('/auth/login');
});
export default router